import React from "react";

import { forceArray } from "/lib/helsecore/forceArray";
import SideMenuItemWithAccordion from "./SideMenuItemWithAccordion";
import SideMenuItemLink from "./SideMenuItemLink";

import type { SideMenuItemProps } from "../types.d";

export default function SideMenuItem(props: SideMenuItemProps) {
  const { item } = props;

  const children = item?.children ? forceArray(item.children) : [];

  if (children.length > 0) {
    return <SideMenuItemWithAccordion {...props} />;
  }

  return (
    <li className="nt-border-x-0">
      <SideMenuItemLink {...props} />
    </li>
  );
}
